<template>
    <div class="perk-list tmp-block no-line">
        <div class="title-contents">
            <div class="icon-holder">
                <img src="@/assets/icons/star.svg" alt="">
            </div>
            <h2>Описание привилегий</h2>
        </div>
        <div class="perks" v-if="productsList.length">
            <roll_card v-for="item of productsList" :data="item" :key="item.id"></roll_card>
        </div>
    </div>
</template>

<script>
    import roll_card from '@/elements/roll_card.vue'
    import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
    export default {
        name: "perk_list",
        components:{
            roll_card,
        },
        data:()=>({
            open: false
        }),
        computed: {
            productsList(){
                return this.description || [];
            },
            ...mapGetters('window', ['pcVersion']),
            ...mapState('main', ['description','pending','error'])
        },
        methods: {
            ...mapActions('main', ['getProducts','getDescription']),
            ...mapMutations('loading_progress', ['startLoading', 'finishLoading']),
        },
        created() {
            if(!this.description.length || !this.pending.description){
                this.startLoading()
                this.getDescription().then(() => {
                    this.finishLoading()
                });
            }
        },
    }
</script>

<style scoped lang="scss">
    .perk-list{

        .show-more{
            text-align: center;
            margin-top: 16px;
        }
        .open-list{
            width: 100%;
            display: flex;
            justify-content: center;
        }

        @include tablet{
            padding: 32px 24px !important;
        }
    }
</style>
